<template>
  <div v-if="!loading">
    <div v-if="surveyRooms.length >  0">
      <transition-group name="list" tag="ul" class="list-group qm-rooms-list">
        <room-list-item v-for="room in surveyRooms" :roomId="room.roomId" :roomName="room.roomName" :roomItemsCount="room.roomItemsCount" :key="room.roomId"></room-list-item>
      </transition-group>
    </div>
    <p v-else>No rooms available</p>
    <form @submit.prevent class="form-inline">
      <label for="roomNameSelector" class="sr-only">Room name</label>
      <select v-if="availableRoomNameOptions.length > 0" v-model="selected" class="custom-select qm-room-select" id="roomNameSelector">
        <option v-for="roomName in availableRoomNameOptions" :value="roomName.roomNameId">
          {{ roomName.roomName }}
        </option>
      </select>
      <button v-if="availableRoomNameOptions.length > 0" @click="addRoom" type="button" class="btn btn-turquois">
        <i class="fa fa-plus"></i>
        Add Room
      </button>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import RoomListItem from './RoomListItem.vue'

export default {
  name: 'Rooms',
  components: {
    'room-list-item': RoomListItem
  },
  props: [ 'surveyId' ],
  data: () => ({
    selected: null,
    surveyRooms: [],
    loading: true
  }),
  computed: {
    availableRoomNameOptions () {
      // filter for not yet used room name options
      let availableRoomNameOptions = this.roomNameOptions.filter((roomNameOption) => {
        let notUsed = true
        this.surveyRooms.forEach((surveyRoom) => {
          if (surveyRoom.roomName === roomNameOption.roomName) {
            notUsed = false
          }
        })
        return notUsed
      })
      // sort by roomNameOption alphabetically
      availableRoomNameOptions.sort((a, b) => {
        if (a.roomName < b.roomName) {
          return -1
        }
        if (a.roomName > b.roomName) {
          return 1
        }
        return 0
      })
      return availableRoomNameOptions
    },
    ...mapGetters({
      rooms: 'getAllRooms',
      roomNameOptions: 'getAllRoomNames',
      items: 'getAllItems',
      nextRoomId: 'getNextRoomId'
    })
  },
  created: function () {
    this.$store.dispatch('loadAllRoomNames').then(() => {
      this.$store.dispatch('loadRoomsForSurvey', this.surveyId).then(() => {
        this.$store.dispatch('loadItemsForSurvey', this.surveyId).then(() => {
          this.refreshRoomsList()
        })
      })
    })
  },
  methods: {
    refreshRoomsList () {
      // create array of room objects for the list view
      this.surveyRooms = []
      this.rooms.forEach((room) => {
        let roomName = 'Room'
        let roomNames = this.roomNameOptions.filter((roomName) => {
          return roomName.roomNameId === room.roomNameId
        })
        if (roomNames.length > 0) {
          roomName = roomNames[0].roomName
        }
        let roomItems = this.items.filter((item) => {
          return item.roomId === room.roomId
        })
        this.surveyRooms.push({
          roomId: room.roomId,
          roomName: roomName,
          roomItemsCount: roomItems.length
        })
      })
      // sort by roomId (latest room addition on bottom)
      this.surveyRooms.sort((a, b) => {
        if (a.roomId < b.roomId) {
          return -1
        }
        if (a.roomId > b.roomId) {
          return 1
        }
        return 0
      })
      this.loading = false
    },
    addRoom () {
      if (this.selected !== null && this.roomNameNotUsedYet()) {
        this.$store.dispatch('addRoom', {
          surveyId: this.surveyId,
          nextRoomId: this.nextRoomId,
          roomNameId: this.selected
        }).then(() => {
          this.$store.dispatch('incrementNextRoomId')
          this.$store.dispatch('loadRoomsForSurvey', this.surveyId).then(() => {
            this.refreshRoomsList()
          })
        })
      }
    },
    roomNameNotUsedYet () {
      let result = this.rooms.filter((element) => {
        return element.roomNameId === this.selected
      })
      return !(result.length > 0)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/children/Rooms.vue